/**
 * Gets phone number.
 * @param {object} phoneNumbers
 * @returns {object}
 */
export function getPhoneNumber(phoneNumbers) {
  return phoneNumbers.trackable || phoneNumbers.ppTrackable || phoneNumbers.basicTrackable || phoneNumbers.basic;
}
